import { Avatar, Checkbox, Flex, Input, Skeleton, theme } from 'antd';
import React, { useEffect, useState } from 'react';
import { SearchOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';

export default function ShareList({
    selectedPaperItemID = null,
    selectedAttachmentID = null,
    openMemberListForSignature,
    signatureInviteList,
    setSignatureInviteList,
    selectedCategoryId
}) {
    const { actionState, agendas, agenda, committee, meetingCommonInfo } = useSelector(state => state.meeting);
    const { companyId } = useSelector(state => state.auth);
    const [memberList, setMemberList] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [loading, setLoading] = useState(false)

    const {
        token: {
            colorBgContainer,
            borderRadiusLG,
            colorPrimary,
            colorPrimaryBorder,
            colorTextDescription,
            fontSizeSM
        },
    } = theme.useToken();

    const nameCardContainerStyle = {
        marginTop: 8,
        paddingTop: 8,
        paddingBottom: 8,
        paddingLeft: 4,
        paddingRight: 4,
        borderRadius: borderRadiusLG,
        backgroundColor: colorBgContainer,
        cursor: 'pointer',
    };

    const avatarStyle = {
        backgroundColor: colorPrimaryBorder,
        color: colorPrimary,
        marginLeft: 8
    };

    const chatSummeryStyle = {
        fontSize: fontSizeSM,
        color: colorTextDescription,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '230px',
        display: 'inline-block'
    };

    const checkBoxStyle = {
        marginLeft: 8,
        marginRight: 8
    };

    const getMemberList = () => {
        const selectedCategory = agenda.categories.find(category => category._id === selectedCategoryId)
        let selectedPaperItemDetails = null
        // console.log('selectedCategory :', selectedCategory)
        if (selectedCategory) {
            selectedPaperItemDetails = selectedCategory.items.find(single => (single.isAddedToDB ? single._id : single.id) === selectedPaperItemID)
            console.log('selectedPaperItemDetails :', selectedPaperItemDetails)
        }

        if (!selectedPaperItemDetails) {
            console.error('No matching paper item details found');
            setMemberList([]);
            setSignatureInviteList([]);
            return;
        }

        const { attachments } = selectedPaperItemDetails;
        const selectedAttachment = attachments?.find(single => (single.isAddedToDB ? single._id : single.id) === selectedAttachmentID);

        // console.log('selectedAttachment :', selectedAttachment)
        const {
            shareWith: { type = '', members: selectedMembers = [], } = {},
            eSignature: { members: signatureRequestList = [] } = {}
        } = selectedAttachment;
        setSignatureInviteList((signatureRequestList && signatureRequestList.length > 0) ? signatureRequestList : [])
        
        if (actionState === 'editPaper') {
            // console.log('committee', committee)
            const { participant } = committee || {};
            const { members } = participant || {};
            const { secretaryId, assistantSecretaryId } = meetingCommonInfo || {};

            switch (type) {
                case 'all':
                    // console.log(members)
                    setMemberList(members)
                    break;

                case 'individual':
                    const matchedMembers = members.filter(member => selectedMembers.includes(member.userDetailsId))
                    const tempMembersList2 = members.filter(member => member.userDetailsId === secretaryId || member.userDetailsId === assistantSecretaryId)
                    const combined = matchedMembers.concat(tempMembersList2);
                    const uniqueCombined = combined.filter(
                        (member, index, self) =>
                            self.findIndex(m => m.userDetailsId === member.userDetailsId) === index
                    );
                    // console.log(uniqueCombined)
                    setMemberList(uniqueCombined)
                    break;

                case 'pending':
                    let tempMembersList = members.filter(member => member.userDetailsId === secretaryId || member.userDetailsId === assistantSecretaryId)
                    setMemberList(tempMembersList)
                    break;

                default:
                    setMemberList([]);
                    console.warn('Unknown shareWith type:', type);
                    break;
            }
        }
    };

    useEffect(() => {
        setLoading(true)
        if (openMemberListForSignature) {
            getMemberList();
        }
        else {
            setMemberList([])
        }
        setLoading(false)
    }, [companyId, openMemberListForSignature]);

    const handleCheckboxChange = (userId) => {
        setSignatureInviteList(prevSelected => {
            if (prevSelected.includes(userId)) {
                return prevSelected.filter(id => id !== userId);
            } else {
                return [...prevSelected, userId];
            }
        });
    };

    // Filter the member list based on the search text
    const filteredMembers = memberList.filter(person =>
        person.name.toLowerCase().includes(searchText.toLowerCase())
    );

    return (
        <div>
            <Flex align='center' justify='space-between' style={{ marginBottom: 16 }} gap={12}>
                <Input
                    size='medium'
                    placeholder="Search by name"
                    prefix={<SearchOutlined />}
                    value={searchText}
                    onChange={e => setSearchText(e.target.value)}
                />
            </Flex>
            <Skeleton active loading={loading}>
                {filteredMembers.map((person) => (
                    <Flex key={person.userDetailsId} align='center' justify='flex-start' gap={8} style={nameCardContainerStyle}>
                        <Flex align='center' justify='center'>
                            <Avatar size={36} style={avatarStyle}>
                                {person.name[0]}
                            </Avatar>
                        </Flex>
                        <Flex align='flex-start' justify='flex-start' vertical={true} style={{ width: '100%' }}>
                            <Flex align='center'>
                                <span>{person.name}</span>
                            </Flex>
                            <Flex align='center'>
                                <span style={chatSummeryStyle}>{person.designation || "No Designation"}</span>
                            </Flex>
                        </Flex>
                        <Flex align='center' justify='center'>
                            <Checkbox
                                style={checkBoxStyle}
                                // checked={selectedUsers?.includes(person._id)}
                                checked={signatureInviteList?.includes(person.userDetailsId)}
                                onChange={() => handleCheckboxChange(person.userDetailsId)}
                            />
                        </Flex>
                    </Flex>
                ))}
            </Skeleton>
        </div>
    );
}
